export default {"src":"/_next/static/media/Group-25852.daa26014.svg","height":104,"width":104};